/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description location schema
 */

const addressFieldKeys = {
	line: {
		key: 'line',
		label: 'Street Address',
		value: '',
	},
	city: {
		key: 'city',
		label: 'City',
		value: '',
	},
	state: {
		key: 'state',
		label: 'State',
		value: '',
	},
	postalCode: {
		key: 'postalCode',
		label: 'Zip Code',
		value: '',
	},
	country: {
		key: 'country',
		label: 'Country',
		value: '',
	},
	phone: {
		key: 'phone',
		label: 'Phone',
		value: '',
	},
};

// schema keys
const locationFormFieldKeys = {
	name: {
		key: 'name',
		label: 'Name',
		placeholder: 'E.g.: Main Office',
	},
	line: {
		key: addressFieldKeys.line.key,
		label: addressFieldKeys.line.label,
		placeholder: 'E.g.: 123 Oxford Valley Rd',
	},
	status: {
		key: 'status',
		label: 'Status',
	},
	city: {
		key: addressFieldKeys.city.key,
		label: addressFieldKeys.city.label,
		placeholder: 'E.g.: Yardley',
	},
	phone: {
		key: addressFieldKeys.phone.key,
		label: addressFieldKeys.phone.label,
		placeholder: 'E.g.: 215-255-0000',
	},
	state: {
		key: addressFieldKeys.state.key,
		label: addressFieldKeys.state.label,
		placeholder: 'Select a State',
	},
	postalCode: {
		key: addressFieldKeys.postalCode.key,
		label: addressFieldKeys.postalCode.label,
		placeholder: 'E.g.: 19067',
	},
	country: {
		key: addressFieldKeys.country.key,
		label: addressFieldKeys.country.label,
		placeholder: 'Select a Country',
	},
};

const locationCardFields = {
	address: {
		key: 'address',
		label: 'Address',
	},
	phone: {
		key: locationFormFieldKeys.phone.key,
		label: locationFormFieldKeys.phone.label,
	},
};

export { locationFormFieldKeys, addressFieldKeys, locationCardFields };
